"use client";

import * as React from "react";
import { CircleCheck, Funnel, Target, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "RIGHT MARKET",
  description: "Hyper-local Phoenix data ensures your business lands in the optimal industrial or office corridor instantly.",
  icon: Target
}, {
  title: "RIGHT SPECIALTY",
  description: "Whether it's heavy industrial or creative office, we filter for your specific operational and technical needs.",
  icon: Funnel
}, {
  title: "RIGHT DEAL SIZE",
  description: "From emerging startups to enterprise giants, we secure terms that match your growth trajectory and budget.",
  icon: Users
}, {
  title: "RIGHT NETWORK",
  description: "Access off-market listings through our exclusive Phoenix broker ecosystem and AI-powered sourcing agent.",
  icon: CircleCheck
}];
export default function ASimpleWayToBuildYourTeamInBrazil() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="172554" id="match-logic" className="py-24 md:py-32 bg-[#0D1B2A] text-white overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center max-w-3xl mx-auto mb-20 md:mb-32">
          <h2 className="text-4xl md:text-8xl font-black tracking-tighter mb-6 text-white uppercase italic">
            Match Logic
          </h2>
          <p className="text-slate-400 text-lg md:text-2xl leading-tight font-medium">PocketPal matches every tenant to the right broker based on four criteria.&nbsp;</p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          {}
          <div className="absolute top-6 left-[10%] right-[10%] h-[2px] bg-cyan-500/20 shadow-[0_0_20px_#3CC5F3] hidden md:block rounded-full animate-pulse" />

          <div className="flex flex-col md:flex-row justify-between relative z-10 gap-16 md:gap-4">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className="flex flex-col items-center relative group flex-1">
                  {}
                  {i !== steps.length - 1 && <div className="absolute top-12 left-1/2 w-[2px] h-[calc(100%+4rem)] bg-cyan-500/20 shadow-[0_0_15px_#3CC5F3] md:hidden -z-10 rounded-full" />}

                  <HoverCard openDelay={100} closeDelay={150}>
                    <HoverCardTrigger asChild>
                      <Button variant="outline" size="icon" className="relative h-14 w-14 rounded-lg border-2 border-cyan-500 bg-[#0D1B2A] shadow-[0_0_25px_rgba(60,197,243,0.15)] transition-all duration-300 hover:scale-110 hover:shadow-[0_0_40px_rgba(60,197,243,0.5)] hover:border-cyan-400 hover:bg-cyan-500/10">
                        <Icon className="h-6 w-6 text-cyan-500" />
                        <span className="sr-only">{step.title}</span>
                      </Button>
                    </HoverCardTrigger>
                    <HoverCardContent side="top" align="center" sideOffset={24} className="w-80 p-6 shadow-2xl border-cyan-500/20 bg-[#0D1B2A]/95 backdrop-blur-xl rounded-xl border-t-4 border-t-cyan-500">
                      <div className="space-y-4">
                        <div className="flex items-center gap-3">
                          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-cyan-500/10 border border-cyan-500/30">
                            <Icon className="h-5 w-5 text-cyan-500" />
                          </div>
                          <h4 className="font-bold text-xl text-white uppercase tracking-tight">
                            {step.title}
                          </h4>
                        </div>
                        <p className="text-sm text-slate-300 leading-relaxed font-medium">
                          {step.description}
                        </p>
                      </div>
                    </HoverCardContent>
                  </HoverCard>

                  <div className="mt-8 text-center transition-transform duration-300 group-hover:-translate-y-1">
                    <span className="text-xs font-black text-cyan-500/60 uppercase tracking-[0.2em] block mb-2">
                      Stage 0{i + 1}
                    </span>
                    <h3 className="text-xl font-black text-white uppercase tracking-tight">
                      {step.title}
                    </h3>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}